(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cobb-accessory-showcase"] && !Shopify.designMode) return;
  try {
    
const initCobbAccessories = (section) => {
  if (!section || section.dataset.cobbAccessoriesReady) return;
  section.dataset.cobbAccessoriesReady = 'true';
  const tabs = Array.from(section.querySelectorAll('[data-cobb-accessory-tab]'));
  const panels = Array.from(section.querySelectorAll('[data-cobb-accessory-panel]'));
  const tablist = section.querySelector('.cobb-accessories__tabs');
  const previous = section.querySelector('[data-cobb-accessory-previous]');
  const nextButton = section.querySelector('[data-cobb-accessory-next]');
  let activeIndex = 0;
  const activate = (index) => {
    activeIndex = (index + panels.length) % panels.length;
    tabs.forEach((tab, i) => { const active = i === activeIndex; tab.classList.toggle('is-active', active); tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
    panels.forEach((panel, i) => { const active = i === activeIndex; panel.hidden = !active; panel.classList.toggle('is-active', active); });
    if (tablist) {
      const activeTab = tabs[activeIndex];
      const target = activeTab.offsetLeft - (tablist.clientWidth - activeTab.offsetWidth) / 2;
      tablist.scrollTo({ left: Math.max(0, target), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(index));
    tab.addEventListener('keydown', (event) => {
      let target = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') target = index + 1;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') target = index - 1;
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = tabs.length - 1;
      if (target === null) return;
      event.preventDefault(); activate(target); tabs[activeIndex].focus();
    });
  });
  previous?.addEventListener('click', () => activate(activeIndex - 1));
  nextButton?.addEventListener('click', () => activate(activeIndex + 1));
  panels.forEach((panel) => {
    const pictures = Array.from(panel.querySelectorAll('[data-cobb-accessory-picture]'));
    const thumbs = Array.from(panel.querySelectorAll('[data-cobb-accessory-thumb]'));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => { const index = Number(thumb.dataset.cobbAccessoryThumb); pictures.forEach((picture, i) => { picture.hidden = i !== index; picture.classList.toggle('is-active', i === index); }); thumbs.forEach((item, i) => { const active = i === index; item.classList.toggle('is-active', active); item.setAttribute('aria-pressed', String(active)); }); }));
  });
  let touchStart = 0;
  section.querySelector('.cobb-accessories__panels')?.addEventListener('touchstart', (event) => { touchStart = event.touches[0].clientX; }, { passive: true });
  section.querySelector('.cobb-accessories__panels')?.addEventListener('touchend', (event) => { const distance = event.changedTouches[0].clientX - touchStart; if (Math.abs(distance) > 55) activate(activeIndex + (distance < 0 ? 1 : -1)); }, { passive: true });
  if (tabs.length) activate(0);
};
document.querySelectorAll('[data-cobb-accessories]').forEach(initCobbAccessories);
document.addEventListener('shopify:section:load', (event) => initCobbAccessories(event.target.querySelector('[data-cobb-accessories]')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-compatibility"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-compat]').forEach((section) => {
  const models = Array.from(section.querySelectorAll('[data-cobb-compat-model]'));
  const items = Array.from(section.querySelectorAll('[data-cobb-compat-item]'));
  const rows = Array.from(section.querySelectorAll('[data-cobb-compat-row]'));
  const count = section.querySelector('[data-cobb-compat-count]');
  const fits = (el, family) => family === 'all' || el.dataset[family] === 'true';
  const select = (button) => {
    const family = button.dataset.family;
    section.dataset.family = family;
    models.forEach((m) => {
      const active = m === button;
      m.classList.toggle('is-active', active);
      m.setAttribute('aria-pressed', String(active));
    });
    let visible = 0;
    items.forEach((item) => {
      const show = fits(item, family);
      item.hidden = !show;
      if (show) visible += 1;
    });
    rows.forEach((row) => row.classList.toggle('is-muted', !fits(row, family)));
    if (count) count.textContent = visible;
  };
  models.forEach((button) => button.addEventListener('click', () => select(button)));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-cooking-modes"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-modes]').forEach((section) => {
  const panels = Array.from(section.querySelectorAll('[data-cobb-mode-panel]'));
  const tabs = Array.from(section.querySelectorAll('[data-cobb-mode-tab]'));
  const tablist = section.querySelector('.cobb-modes__nav');
  const previous = section.querySelector('[data-cobb-mode-previous]');
  const nextButton = section.querySelector('[data-cobb-mode-next]');
  if (!panels.length || !tabs.length) return;
  let activeIndex = 0;
  const activate = (index) => {
    activeIndex = (index + panels.length) % panels.length;
    panels.forEach((panel, i) => { const active = i === activeIndex; panel.hidden = !active; panel.classList.toggle('is-active', active); });
    tabs.forEach((tab, i) => { const active = i === activeIndex; tab.classList.toggle('is-active', active); tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
    if (tablist) {
      const activeTab = tabs[activeIndex];
      const target = activeTab.offsetLeft - (tablist.clientWidth - activeTab.offsetWidth) / 2;
      tablist.scrollTo({ left: Math.max(0, target), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(index));
    tab.addEventListener('keydown', (event) => {
      if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const target = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1);
      activate(target); tabs[activeIndex].focus();
    });
  });
  previous?.addEventListener('click', () => activate(activeIndex - 1));
  nextButton?.addEventListener('click', () => activate(activeIndex + 1));
  let touchStart = 0;
  section.querySelector('.cobb-modes__panels')?.addEventListener('touchstart', (event) => { touchStart = event.touches[0].clientX; }, { passive: true });
  section.querySelector('.cobb-modes__panels')?.addEventListener('touchend', (event) => { const distance = event.changedTouches[0].clientX - touchStart; if (Math.abs(distance) > 55) activate(activeIndex + (distance < 0 ? 1 : -1)); }, { passive: true });
  activate(0);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-fuel-guide"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-fuel-guide]').forEach((section) => {
  const chips = Array.from(section.querySelectorAll('[data-cobb-fuel-chip]'));
  const cards = Array.from(section.querySelectorAll('[data-cobb-fuel-card]'));
  const narrow = window.matchMedia('(max-width: 989px)');
  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      const selected = chip.getAttribute('aria-pressed') !== 'true';
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip && selected)));
      if (!selected) {
        section.removeAttribute('data-active');
        cards.forEach((card) => card.classList.remove('is-match'));
        return;
      }
      section.setAttribute('data-active', chip.dataset.cobbFuelChip);
      cards.forEach((card) => card.classList.toggle('is-match', card.dataset.cobbFuelCard === chip.dataset.cobbFuelChip));
      const match = cards.find((card) => card.dataset.cobbFuelCard === chip.dataset.cobbFuelChip);
      if (match && narrow.matches) match.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-how-it-works"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-how]').forEach((section) => {
  const controls = Array.from(section.querySelectorAll('[data-cobb-how-part]'));
  const activate = (index) => {
    controls.forEach((control) => {
      const active = control.dataset.cobbHowPart === String(index);
      control.classList.toggle('is-active', active);
      control.setAttribute('aria-pressed', String(active));
    });
  };
  controls.forEach((control) => {
    control.addEventListener('click', () => activate(control.dataset.cobbHowPart));
    if (control.classList.contains('cobb-how__hotspot')) control.addEventListener('mouseenter', () => activate(control.dataset.cobbHowPart));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-life-navigator"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-life]').forEach((section) => {
  const rail = section.querySelector('[data-cobb-life-rail]'); const cards = Array.from(section.querySelectorAll('[data-cobb-life-card]')); const backgrounds = Array.from(section.querySelectorAll('.cobb-life__backdrop-image')); const previous = section.querySelector('[data-cobb-life-previous]'); const next = section.querySelector('[data-cobb-life-next]'); const pause = section.querySelector('[data-cobb-life-pause]'); const progress = section.querySelector('[data-cobb-life-progress]'); const status = section.querySelector('[data-cobb-life-status]'); const reduced = window.matchMedia('(prefers-reduced-motion: reduce)'); if (!rail || !cards.length) return;
  const ofLabel = section.dataset.ofLabel || ' / '; let active = Math.min(Number(section.dataset.startIndex) || 0, cards.length - 1); let paused = reduced.matches; let timer; const interval = Math.max(Number(section.dataset.autoplaySeconds) || 6, 4) * 1000;
  const setActive = (index, scroll = true) => { active = (index + cards.length) % cards.length; cards.forEach((card, i) => card.classList.toggle('is-active', i === active)); backgrounds.forEach((background, i) => background.classList.toggle('is-active', i === active)); if (progress) progress.style.width = `${((active + 1) / cards.length) * 100}%`; if (status) status.textContent = `${cards[active].querySelector('.cobb-life__label')?.textContent || ''}, ${active + 1}${ofLabel}${cards.length}`; if (scroll) { const card = cards[active]; rail.scrollTo({ left: card.offsetLeft - (rail.clientWidth - card.clientWidth) / 2, behavior: reduced.matches ? 'auto' : 'smooth' }); } };
  const stop = () => window.clearInterval(timer); const start = () => { stop(); if (!paused && !reduced.matches && cards.length > 1) timer = window.setInterval(() => setActive(active + 1), interval); }; const move = (direction) => { setActive(active + direction); start(); };
  previous?.addEventListener('click', () => move(-1)); next?.addEventListener('click', () => move(1)); pause?.addEventListener('click', () => { paused = !paused; pause.setAttribute('aria-pressed', String(paused)); pause.textContent = paused ? pause.dataset.resumeLabel : pause.dataset.pauseLabel; start(); }); rail.addEventListener('mouseenter', stop); rail.addEventListener('mouseleave', start); rail.addEventListener('focusin', stop); rail.addEventListener('focusout', start); reduced.addEventListener?.('change', () => { paused = reduced.matches; start(); }); setActive(active, active > 0); start();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-product-stage"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-stage]').forEach((section) => {
  const tabs = Array.from(section.querySelectorAll('[data-cobb-stage-tab]'));
  const base = section.querySelector('.cobb-stage__image');
  const detailImages = Array.from(section.querySelectorAll('[data-cobb-stage-image]'));
  const previous = section.querySelector('[data-cobb-stage-previous]');
  const nextButton = section.querySelector('[data-cobb-stage-next]');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!tabs.length) return;
  let activeIndex = 0;
  const activate = (index, reveal = true) => {
    activeIndex = (index + tabs.length) % tabs.length;
    tabs.forEach((tab, i) => { const active = i === activeIndex; tab.classList.toggle('is-active', active); tab.setAttribute('aria-selected', String(active)); tab.tabIndex = active ? 0 : -1; });
    if (detailImages.length) { const target = detailImages.find((image) => Number(image.dataset.cobbStageImage) === activeIndex); if (base) base.classList.toggle('is-active', !target); detailImages.forEach((image) => image.classList.toggle('is-active', image === target)); }
    if (reveal) tabs[activeIndex].scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
  };
  tabs.forEach((tab, index) => { tab.addEventListener('click', () => activate(index)); tab.addEventListener('keydown', (event) => { if (!['ArrowDown','ArrowRight','ArrowUp','ArrowLeft'].includes(event.key)) return; event.preventDefault(); activate(index + (event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1)); tabs[activeIndex].focus(); }); });
  previous?.addEventListener('click', () => activate(activeIndex - 1));
  nextButton?.addEventListener('click', () => activate(activeIndex + 1));
  activate(0, false);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobb-system-grid"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-system]').forEach((section) => {
  const rail = section.querySelector('[data-cobb-system-rail]');
  const cards = Array.from(section.querySelectorAll('[data-cobb-system-card]'));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!rail || cards.length < 2) return;
  let active = 0;
  const move = (direction) => { active = (active + direction + cards.length) % cards.length; cards[active].scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' }); };
  section.querySelector('[data-cobb-system-previous]')?.addEventListener('click', () => move(-1));
  section.querySelector('[data-cobb-system-next]')?.addEventListener('click', () => move(1));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-section"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cobb-quality]').forEach((section) => {
  const modes = Array.from(section.querySelectorAll('[data-cobb-quality-mode]'));
  const desktop = window.matchMedia('(hover: hover) and (min-width: 1200px)');
  const activate = (mode) => {
    modes.forEach((item) => {
      const active = item === mode;
      item.classList.toggle('is-active', active);
      item.querySelector('.cobb-quality__trigger').setAttribute('aria-expanded', String(active));
    });
  };
  modes.forEach((mode) => {
    mode.querySelector('.cobb-quality__trigger').addEventListener('click', () => activate(mode));
    mode.addEventListener('mouseenter', () => { if (desktop.matches) activate(mode); });
    mode.addEventListener('focusin', () => activate(mode));
  });
});

  } catch(e) { console.error(e); }
})();
})();
